import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart } from "../app-cart";
import { Gtm } from "../app-gtm";

const divRoot: HTMLDivElement = document.querySelector("#ko-review");
const divModel: HTMLDivElement = document.querySelector("#divRegisterReviewModel");

export class ViewModel {
    busy = ko.observable(false);
    //cart: Cart;

    cart = ko.observable<Cart>();

    next: () => void;

    constructor(model: any) {
        let self = this;

        var data = JSON.parse(model);

        self.cart(new Cart(data.cart, data.returnUrl));

        self.busy.subscribe(newVal => App.busy(newVal));

        self.next = () => {
            if (!self.busy())
                self.review();
        }

        //App.onEnter("#reviewSection", self.next);
        Gtm.review(self.cart());
    }

    private review() {
        let self = this;

        self.busy(true);

        Api.Review()
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());